// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"_2G_anGCX9ozBDadN1d7mg4","Dialog":"_1oo5jf328JZb6GEkq4xktv"};